import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NotificationsState } from '../reducers/notification.reducer';

export const selectNotifications =
  createFeatureSelector<NotificationsState>('notifications');

export const selectUnreadNotificationsCount = createSelector(
  selectNotifications,
  (state: NotificationsState) => state.unread,
);

export const selectNotificationItems = createSelector(
  selectNotifications,
  (state: NotificationsState) => state.items,
);

export const selectUnreadNotificationIds = createSelector(
  selectNotificationItems,
  (items) => items.filter((item) => !item.readAt).map((item) => item.id),
);
